import { tw } from "@sveabank/cc-common";

const LinearProgress = ({ value }: { value: number }) => (
	<div
		className={tw(
			`bg-background-primary relative mt-1 overflow-hidden rounded-full border-2 p-[5px]`,
			value < 1 ? "border-foreground-critical" : "border-background-dark",
		)}
	>
		<span
			className={tw(
				`bg-background-dark absolute top-0 left-0 h-full w-4 rounded-r-md transition-all duration-500 ease-out`,
			)}
			style={{ width: `${value}%` }}
		/>
	</div>
);

export default LinearProgress;
